import { render, staticRenderFns } from "./ClaimReason.vue?vue&type=template&id=b41258a0&"
import script from "./ClaimReason.vue?vue&type=script&lang=js&"
export * from "./ClaimReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b41258a0')) {
      api.createRecord('b41258a0', component.options)
    } else {
      api.reload('b41258a0', component.options)
    }
    module.hot.accept("./ClaimReason.vue?vue&type=template&id=b41258a0&", function () {
      api.rerender('b41258a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimReason/ClaimReason.vue"
export default component.exports